
import { useBillsState } from "./bills/useBillsState";
import { useBillsFilter } from "./bills/useBillsFilter";
import { useBillsFetch } from "./bills/useBillsFetch";
import { useBillsForSchool } from "./bills/useBillsForSchool";

export function useBills() {
  const {
    bills,
    setBills,
    loading,
    setLoading,
    fetchComplete,
    setFetchComplete,
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    resetFetchState
  } = useBillsState();

  const { filteredBills } = useBillsFilter(bills, searchTerm, statusFilter);
  
  const { fetchBills } = useBillsFetch(
    setLoading,
    setBills,
    setFetchComplete,
    fetchComplete
  );
  
  const { fetchBillsForSchool } = useBillsForSchool(
    setLoading,
    setBills,
    setFetchComplete,
    fetchComplete
  );

  return {
    bills: filteredBills,
    loading,
    fetchBills,
    fetchBillsForSchool,
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    resetFetchState
  };
}
